function dispatchEvent({ eventName, node, detail }) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail,
  });
  node.dispatchEvent(event);
}

export { dispatchEvent };
